import HeaderSection from "@/components/Header/HeaderSection.vue";
import BolideAssistant from "@/components/BolideAssistant/BolideAssistant.vue";
import SettingsUserManagementTab from "@/components/SettingsUserManagementTab/SettingsUserManagementTab.vue";
import { get_user_profile, fetch_and_store_user_profile } from "@/router";

export default {
    name: "UserManagementSection",

    components: {
        HeaderSection,
        BolideAssistant,
        SettingsUserManagementTab
    },

    data() {
        return ({
            show_assistant: false,
            user_profile: null,
            breadcrumb: [
                { id: "home", title: "Dashboard" },
                { id: "user_management", title: "User Management" }
            ]
        });
    },

    async mounted() {
        this.user_profile = get_user_profile() || await fetch_and_store_user_profile();
    },

    methods: {
        handleBreadcrumbClick(id) {
            if (id === "home") {
                this.$router.push("/home");
            }
        }
    }
};
